import React from 'react';

import { generateFallbackColor } from '../../../helpers';

import { ScreenshotPreviewView } from './ScreenshotPreviewView';

import type { ScreenshotPreviewProperties } from './ScreenshotPreview.types';

export const ScreenshotPreview: React.FC<ScreenshotPreviewProperties> = ({
  isPending,
  screenshotUrl = '',
  url = '',
  urlNormalised = '',
  dataTest = 'screenshot_preview',
}) => {
  const [imageError, setImageError] = React.useState(false);
  const showFallback = !screenshotUrl || imageError;
  const fallbackColor = React.useMemo(() => generateFallbackColor(url), [url]);
  const handleImageError = React.useCallback(() => setImageError(true), []);

  return (
    <ScreenshotPreviewView
      isPending={isPending}
      showFallback={showFallback}
      fallbackColor={fallbackColor}
      screenshotUrl={screenshotUrl}
      url={url}
      urlNormalised={urlNormalised}
      onImageError={handleImageError}
      dataTest={dataTest}
    />
  );
};
